import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';
import React from 'react';

import CheckList, { ICheckListProps } from './checklist/CheckList';
import { CheckListContainerAdapter } from './ChecklistContainerAdapter';

export { CheckList, CheckListContainerAdapter };

export type { ICheckListProps };

export interface CheckListContainerProps {
  headline?: string;
  checkLists: ICheckListProps[];
  onGreyBackground: boolean;
  component: string;
  _uid: string;
  _editable?: string;
}

const CheckListContainer: React.FC<CheckListContainerProps> = (
  props: CheckListContainerProps
) => {
  const { checkLists, headline, onGreyBackground = false } = props;

  const className = {
    wrapper: clsx(
      'grid grid-cols-24 grid-rows-[auto_auto_auto] sm:py-40px lg:py-100px',
      onGreyBackground ? 'bg-grey10' : 'bg-white'
    ),
    headline: clsx(
      'col-end-24 col-start-2 flex font-headline font-weight-bold justify-between pb-40px row-end-2 row-start-1 text-grey100 text-headline2 lg:col-end-19'
    ),
    benefitList: clsx(
      'col-end-24 col-start-2 flex flex-col row-end-3 row-start-2 lg:flex-row'
    ),
    textLink: clsx(
      'col-end-24 col-start-2 ml-[2px] mt-40px row-end-4 row-start-3 lg:col-start-18 lg:justify-self-end lg:mt-0 lg:pb-40px lg:row-end-2 lg:row-start-1'
    ),
  };

  return (
    <div {...sbEditable(props)} className={className.wrapper}>
      {headline && <h2 className={className.headline}>{headline}</h2>}
      <div className={className.benefitList}>
        {checkLists.map((checkList, idx) => (
          <CheckList key={`checklist-${idx}`} list={checkList} />
        ))}
      </div>
    </div>
  );
};

export default CheckListContainer;
